import { Grid } from '@mui/material';
import styles from './styles.module.css';
import BillFormat from './BillFormat';
import ShopSettings from './ShopSettings';
import ChargesDiscounts from './ChargesDiscounts';
// import ShopUsersList from './ShopUsersList';
// import ShortKey from './ShortKey';
import ShopProfile from './ShopProfile';
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import withConsoleBase from 'components/utils/ConsoleBase/withConsoleBase';
import PaymentModes from './PaymentModes';
import OrderActions from './OrderActions';
import Tables from './Tables';
import Units from './Units';
import PriceCategory from './PriceCategory';
import ExpenseType from './ExpenseType';
import QuickbookSettings from './QuickbookSettings';
import { useHistory, useParams } from 'react-router-dom';
import FailedJobs from './FailedJobs';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ROUTES, SANOFT_DEALER } from 'const';
import VariantConfig from './VariantConfig';
import ZohoSettings from './ZohoSettings';
import { ShopContext } from 'Context/ShopContext';
import ShopsHelper from 'helpers/ShopsHelper';
import OrderTypes from './OrderTypes';

const tabStyleActive = {
  backgroundColor: '#FC9A02',
  color: '#fff',
};

const tabStyle = {
  color: '#000',
};

const NAVIGATION_TAB = {
  INVOICE_FORMAT: 'invoice-format',
  SHORT_KEY: 'short-key',
  SETTINGS: 'settings',
  USERS: 'users',
  PROFILE: 'profile',
  PAYMENT_MODES: 'payment-modes',
  ORDER_ACTIONS: 'order-actions',
  UNITS: 'units',
  PRICE_CATEGORY: 'price-category',
  EXPENSE_TYPE: 'expense-type',
  POS_SETTINGS: 'pos-settings',
  QUICKBOOK: 'quickbook',
  TABLES: 'tables',
  FAILED_JOBS: 'failed-jobs',
  VARIANT_CONFIG: 'variant-config',
  CHARGES_AND_DISCOUNTS: 'charges-and-discounts',
  ZOHO: 'zohobook',
  ORDER_TYPES: 'order-types',
};

function SettingsPage(props) {
  const { tab } = useParams();
  const history = useHistory();
  const { shop } = useContext(ShopContext);
  const [selectedTab, setSelectedTab] = useState(tab ?? NAVIGATION_TAB.PROFILE);
  const { t: tCommon } = useTranslation('common');

  const handleTabSelection = (tab) => {
    history.push(ROUTES.SETTINGS_TAB.replace(':tab', tab));
    setSelectedTab(tab);
  };

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);

  const isSanoftDealer =
    (!shop?.dealer ||
      shop?.dealer?.name === SANOFT_DEALER ||
      shop?.dealer?.name === 'SANOFT DIRECT' ||
      shop?.dealer?.name?.toUpperCase() === 'SANOFT') &&
    (!shop?.dealer || shop?.dealer?.is_online_renewal_enabled === true);

  const handleWhatsAppRedirect = () => {
    const phone = '919074511134';
    const message = `${shop?.shop_name || ''} (${shop?.id || ''})\nNeed help on Sanoft POS`;
    const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className={styles.contentsArea}>
      <div className={styles.headingDiv}>
        <span className={styles.pageHead}>{tCommon('Settings')}</span>
      </div>
      <div className={styles.changeable}>
        <Grid className={styles.settingsTab}>
          <div
            className={styles.navItem}
            style={selectedTab === NAVIGATION_TAB.PROFILE ? tabStyleActive : tabStyle}
            onClick={() => {
              handleTabSelection(NAVIGATION_TAB.PROFILE);
            }}
          >
            <span className={styles.title}>{tCommon('Profile')}</span>
          </div>
          <div
            className={styles.navItem}
            style={selectedTab === NAVIGATION_TAB.INVOICE_FORMAT ? tabStyleActive : tabStyle}
            onClick={() => {
              handleTabSelection(NAVIGATION_TAB.INVOICE_FORMAT);
            }}
          >
            <h3 className={styles.title}>{tCommon('Invoice Format')}</h3>
          </div>
          <div
            className={styles.navItem}
            style={selectedTab === NAVIGATION_TAB.PAYMENT_MODES ? tabStyleActive : tabStyle}
            onClick={() => {
              handleTabSelection(NAVIGATION_TAB.PAYMENT_MODES);
            }}
          >
            <span className={styles.title}>{tCommon('Payment Modes')}</span>
          </div>
          <div
            className={styles.navItem}
            style={selectedTab === NAVIGATION_TAB.SETTINGS ? tabStyleActive : tabStyle}
            onClick={() => {
              handleTabSelection(NAVIGATION_TAB.SETTINGS);
            }}
          >
            <span className={styles.title}>{tCommon('Settings')}</span>
          </div>
          <div
            className={styles.navItem}
            style={selectedTab === NAVIGATION_TAB.UNITS ? tabStyleActive : tabStyle}
            onClick={() => {
              handleTabSelection(NAVIGATION_TAB.UNITS);
            }}
          >
            <span className={styles.title}>{tCommon('Units')}</span>
          </div>
          {ShopsHelper.hasPremiumAccess(shop) && (
            <>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.TABLES ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.TABLES);
                }}
              >
                <span className={styles.title}>{tCommon('Tables')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.PRICE_CATEGORY ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.PRICE_CATEGORY);
                }}
              >
                <span className={styles.title}>{tCommon('Price Category')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.EXPENSE_TYPE ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.EXPENSE_TYPE);
                }}
              >
                <span className={styles.title}>{tCommon('Expense Type')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.CHARGES_AND_DISCOUNTS ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.CHARGES_AND_DISCOUNTS);
                }}
              >
                <span className={styles.title}>{tCommon('Charges & Discounts')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.ORDER_TYPES ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.ORDER_TYPES);
                }}
              >
                <span className={styles.title}>{tCommon('Order Types')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.VARIANT_CONFIG ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.VARIANT_CONFIG);
                }}
              >
                <span className={styles.title}>{tCommon('Variant Config')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.ORDER_ACTIONS ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.ORDER_ACTIONS);
                }}
              >
                <span className={styles.title}>{tCommon('Order Actions')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.QUICKBOOK ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.QUICKBOOK);
                }}
              >
                <span className={styles.title}>{tCommon('Quickbook')}</span>
              </div>
              <div
                className={styles.navItem}
                style={selectedTab === NAVIGATION_TAB.ZOHO ? tabStyleActive : tabStyle}
                onClick={() => {
                  handleTabSelection(NAVIGATION_TAB.ZOHO);
                }}
              >
                <span className={styles.title}>Zoho</span>
              </div>
            </>
          )}
          <div
            className={styles.navItem}
            style={selectedTab === NAVIGATION_TAB.FAILED_JOBS ? tabStyleActive : tabStyle}
            onClick={() => {
              handleTabSelection(NAVIGATION_TAB.FAILED_JOBS);
            }}
          >
            <span className={styles.title}>{tCommon('Failed Jobs')}</span>
          </div>
        </Grid>

        {selectedTab === NAVIGATION_TAB.INVOICE_FORMAT && <BillFormat />}
        {selectedTab === NAVIGATION_TAB.SETTINGS && <ShopSettings />}
        {selectedTab === NAVIGATION_TAB.PROFILE && <ShopProfile />}
        {selectedTab === NAVIGATION_TAB.PAYMENT_MODES && <PaymentModes />}
        {selectedTab === NAVIGATION_TAB.ORDER_ACTIONS && ShopsHelper.hasPremiumAccess(shop) && <OrderActions />}
        {selectedTab === NAVIGATION_TAB.UNITS && <Units />}
        {selectedTab === NAVIGATION_TAB.TABLES && ShopsHelper.hasPremiumAccess(shop) && <Tables />}
        {selectedTab === NAVIGATION_TAB.PRICE_CATEGORY && ShopsHelper.hasPremiumAccess(shop) && <PriceCategory />}
        {selectedTab === NAVIGATION_TAB.EXPENSE_TYPE && ShopsHelper.hasPremiumAccess(shop) && <ExpenseType />}
        {selectedTab === NAVIGATION_TAB.QUICKBOOK && ShopsHelper.hasPremiumAccess(shop) && <QuickbookSettings />}
        {selectedTab === NAVIGATION_TAB.ZOHO && ShopsHelper.hasPremiumAccess(shop) && <ZohoSettings />}
        {selectedTab === NAVIGATION_TAB.FAILED_JOBS && <FailedJobs />}
        {selectedTab === NAVIGATION_TAB.VARIANT_CONFIG && ShopsHelper.hasPremiumAccess(shop) && <VariantConfig />}
        {selectedTab === NAVIGATION_TAB.CHARGES_AND_DISCOUNTS && ShopsHelper.hasPremiumAccess(shop) && (
          <ChargesDiscounts />
        )}
        {selectedTab === NAVIGATION_TAB.ORDER_TYPES && ShopsHelper.hasPremiumAccess(shop) && <OrderTypes />}
      </div>
      {(tab || selectedTab) === NAVIGATION_TAB.SETTINGS && isSanoftDealer && (
        <div className={styles.floatingWhatsappBtn} onClick={handleWhatsAppRedirect}>
          <WhatsAppIcon style={{ fontSize: '32px', color: '#fff' }} />
        </div>
      )}
    </div>
  );
}

export default withConsoleBase(SettingsPage);
